import { deserializeApp, NamedScreenTemplate, DeserializedRootScreen } from "common/components/deserialization";
import { SerializedApp } from "common/components/SerializedApp";
import { logError, logInfo } from "common/debug-print";
import { Context, AppEnvironment, Evaluable, AppOther } from "common/components/types";
import { Data } from "common/components/data";
import { ForwardingAppEnvironment } from "./forwarding-app-environment";

// FIXME: This is just a generic copy of `DeserializedApp`
export interface GlideAppState {
    readonly rootContext: Context;
    readonly functions: ReadonlyMap<string, Evaluable>;
    readonly screens: ReadonlyMap<string, NamedScreenTemplate>;
    readonly computedColumns: Map<string, Map<string, Evaluable>>;
}

export function glideAppStateFromProps(
    serializedApp: SerializedApp,
    appEnvironment: AppEnvironment,
    getRootScreens: (
        screens: readonly DeserializedRootScreen[],
        functions: ReadonlyMap<string, Evaluable>
    ) => { screens: readonly DeserializedRootScreen[]; functions: ReadonlyMap<string, Evaluable> }
): { state: GlideAppState; evaluatedRoots: readonly DeserializedRootScreen[] | undefined } {
    // logInfo(props.serializedApp);
    // printSubscriptions();
    try {
        const { functions, screens, rootTabs, rootContext, computedColumns } = deserializeApp(
            serializedApp,
            appEnvironment
        );
        const { screens: realRootScreens, functions: newFunctions } = getRootScreens(rootTabs, functions);

        const state: GlideAppState = {
            rootContext,
            functions: newFunctions,
            screens,
            computedColumns,
        };

        return { state, evaluatedRoots: realRootScreens };
    } catch (e: unknown) {
        logError("Exception when deserializing app", e);
        logInfo(serializedApp);
        const state: GlideAppState = {
            rootContext: new Data<AppOther, AppEnvironment>(undefined),
            functions: new Map(),
            screens: new Map(),
            computedColumns: new Map(),
        };
        return { state, evaluatedRoots: undefined };
    }
}

export interface GlideAppPropsBase {
    appEnvironment: ForwardingAppEnvironment;
    useFrame?: boolean;
}
